// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__18vFr","content":"styles_content__1dfp-"};